// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.inv-form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px 18px;
}

.inv-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.inv-form-grid .inv-field {
  margin-bottom: 0;
}

.inv-field--full {
  grid-column: 1/-1;
}

.inv-key-notice {
  grid-column: 1/-1;
  background: #fff8e6;
  border: 1px solid #f3e0a8;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 12px;
  color: #8a6d1a;
  line-height: 1.5;
}

.inv-field label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 6px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.inv-field .form-control {
  height: auto;
  padding: 9px 12px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  box-shadow: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.inv-field .form-control::placeholder {
  color: #ccc;
}
.inv-field .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
  outline: none;
}

@media (max-width: 640px) {
  .inv-form-grid {
    grid-template-columns: 1fr;
  }
}
.inv-field__label-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}
.inv-field__label-row label {
  margin-bottom: 0;
}

.inv-neworg__toggle {
  padding: 0;
  border: none;
  background: none;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgb(105, 190, 40);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: color 0.15s ease;
}
.inv-neworg__toggle .fa {
  font-size: 10px;
}
.inv-neworg__toggle:hover {
  color: #52941f;
  text-decoration: underline;
}

.inv-orgselect {
  position: relative;
  margin-top: 6px;
}
.inv-orgselect__control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  text-align: left;
  cursor: pointer;
}
.inv-orgselect__control.is-placeholder .inv-orgselect__value {
  color: #ccc;
}
.inv-orgselect__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inv-orgselect__caret {
  color: #ccc;
  font-size: 13px;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}
.inv-orgselect.is-open .inv-orgselect__caret {
  transform: rotate(180deg);
}
.inv-orgselect__menu {
  position: absolute;
  z-index: 20;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  box-shadow: 0 8px 24px -12px rgba(51, 51, 51, 0.28), 0 2px 6px rgba(51, 51, 51, 0.06);
  overflow: hidden;
}
.inv-orgselect__search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border-bottom: 1px solid #e7eaec;
}
.inv-orgselect__search .fa {
  color: #ccc;
  font-size: 13px;
}
.inv-orgselect__search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #676a6c;
  background: transparent;
}
.inv-orgselect__search-input::placeholder {
  color: #ccc;
}
.inv-orgselect__list {
  list-style: none;
  margin: 0;
  padding: 4px;
  max-height: 220px;
  overflow-y: auto;
}
.inv-orgselect__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 5px;
  font-size: 13px;
  color: #676a6c;
  cursor: pointer;
}
.inv-orgselect__option .fa-check {
  color: rgb(105, 190, 40);
  font-size: 12px;
  flex-shrink: 0;
}
.inv-orgselect__option.is-active {
  background: rgba(0, 173, 208, 0.1);
}
.inv-orgselect__option.is-selected {
  font-weight: 600;
}
.inv-orgselect__option-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inv-orgselect__empty {
  padding: 12px 10px;
  font-size: 13px;
  color: #ccc;
  text-align: center;
  line-height: 1.5;
}
.inv-orgselect__create {
  display: inline;
  border: none;
  background: none;
  padding: 0;
  margin-left: 4px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgb(105, 190, 40);
  cursor: pointer;
}
.inv-orgselect__create:hover {
  text-decoration: underline;
}

.inv-neworg {
  margin-top: 6px;
  padding: 12px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #f1f1f2;
}
.inv-neworg__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}
.inv-neworg .btn-xs {
  padding: 5px 12px;
  font-size: 12px;
}

.inv-followup {
  display: flex;
  align-items: center;
  gap: 8px;
}
.inv-followup__toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  color: #676a6c;
  cursor: pointer;
}
.inv-followup__toggle input {
  cursor: pointer;
  margin: 0;
}
.inv-followup__sample {
  margin-left: auto;
  border: none;
  background: none;
  color: rgb(0, 173, 208);
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1;
  padding: 4px 2px;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color 0.15s ease;
}
.inv-followup__sample:hover {
  color: #007a93;
}
.inv-followup__sample:focus-visible {
  outline: 2px solid rgb(0, 173, 208);
  outline-offset: 2px;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/invitations/create/steps/step-details.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA1YA;EAAiB,aAAA;EAAe,0BAAA;EAA4B,cAAA;AAgZ5D;;AA/YA;EAAa,aAAA;EAAe,sBAAA;EAAwB,mBAAA;AAqZpD;;AApZA;EAA4B,gBAAA;AAwZ5B;;AAvZA;EAAmB,iBAAA;AA2ZnB;;AA1ZA;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA6ZF;;AA3ZA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDiBmB;EChBnB,kBAAA;EACA,wEDzBW;ACubb;;AA5ZA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,wED/BW;ECgCX,cDGmB;ECFnB,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wDAAA;AA+ZF;AA9ZE;EAAiB,WDIC;AC6ZpB;AAhaE;EAAU,8BDlBI;ECkB0B,4CAAA;EAAiD,aAAA;AAqa3F;;AAnaA;EAA4B;IAAiB,0BAAA;EAwa3C;AACF;AAtaA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;AAwaF;AAtaE;EAAQ,gBAAA;AAyaV;;AAraA;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,wED1DW;EC2DX,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBDxCc;ECyCd,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,4BAAA;AAwaF;AAtaE;EAAM,eAAA;AAyaR;AAxaE;EAAU,cAAA;EAAoC,0BAAA;AA4ahD;;AAxaA;EACE,kBAAA;EACA,eAAA;AA2aF;AAzaE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AA2aJ;AAzaI;EAAyC,WD9CzB;AC0dpB;AA1aE;EAAW,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AA+axD;AA9aE;EAAW,WDjDO;ECiDoB,eAAA;EAAiB,cAAA;EAAgB,gCAAA;AAobzE;AAnbE;EAAqB,yBAAA;AAsbvB;AApbE;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qFAAA;EACA,gBAAA;AAsbJ;AAnbE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gCAAA;AAqbJ;AAnbI;EAAM,WDxEU;ECwEiB,eAAA;AAubrC;AArbE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,wEDzHS;EC0HT,eAAA;EACA,cDxFiB;ECyFjB,uBAAA;AAubJ;AAtbI;EAAiB,WDnFD;AC4gBpB;AAtbE;EACE,gBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAwbJ;AAtbE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cD5GiB;EC6GjB,eAAA;AAwbJ;AAtbI;EAAY,wBD3HA;EC2HuB,eAAA;EAAiB,cAAA;AA2bxD;AA1bI;EAAc,kCAAA;AA6blB;AA5bI;EAAgB,gBAAA;AA+bpB;AA7bE;EAAiB,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAkc9D;AAhcE;EACE,kBAAA;EACA,eAAA;EACA,WDjHgB;ECkHhB,kBAAA;EACA,gBAAA;AAkcJ;AAhcE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,wEDrKS;ECsKT,eAAA;EACA,gBAAA;EACA,wBDjJY;ECkJZ,eAAA;AAkcJ;AAjcI;EAAU,0BAAA;AAocd;;AAhcA;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBDxIoB;AC2kBtB;AAjcE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AAmcJ;AAjcE;EAAU,iBAAA;EAAmB,eAAA;AAqc/B;;AAjcA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAocF;AAlcE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,cDvKiB;ECwKjB,eAAA;AAocJ;AAlcI;EAAQ,eAAA;EAAiB,SAAA;AAsc7B;AAlcE;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBDhMY;ECiMZ,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,wEDzNS;EC0NT,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,4BAAA;AAocJ;AAlcI;EAAU,cAAA;AAqcd;AApcI;EAAkB,mCAAA;EAAmC,mBAAA;EAAqB,kBAAA;AAyc9E","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../../assets/styles/variables\";\n\n// Form grid + fields (lives here so the form is styled wherever step-details\n// renders — the create wizard modal AND the edit modal)\n// Single column: fields stack top-to-bottom in the wizard/edit modals.\n.inv-form-grid { display: grid; grid-template-columns: 1fr; gap: 16px 18px; }\n.inv-field { display: flex; flex-direction: column; margin-bottom: 16px; }\n.inv-form-grid .inv-field { margin-bottom: 0; }\n.inv-field--full { grid-column: 1 / -1; }\n.inv-key-notice {\n  grid-column: 1 / -1;\n  background: #fff8e6;\n  border: 1px solid #f3e0a8;\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-size: 12px;\n  color: #8a6d1a;\n  line-height: 1.5;\n}\n.inv-field label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $color-neutral-dark;\n  margin-bottom: 6px;\n  font-family: $font-stack;\n}\n.inv-field .form-control {\n  height: auto;\n  padding: 9px 12px;\n  font-size: 13px;\n  font-family: $font-stack;\n  color: $body-content-color;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  &::placeholder { color: $color-neutral-mid; }\n  &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); outline: none; }\n}\n@media (max-width: 640px) { .inv-form-grid { grid-template-columns: 1fr; } }\n\n// Label row: field label on the left, \"+ New\" org link aligned right\n.inv-field__label-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n\n  label { margin-bottom: 0; }\n}\n\n// \"+ New\" organization link (aligned with the Organization label)\n.inv-neworg__toggle {\n  padding: 0;\n  border: none;\n  background: none;\n  font-family: $font-stack;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $develop-color;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  transition: color 0.15s ease;\n\n  .fa { font-size: 10px; }\n  &:hover { color: darken($develop-color, 10%); text-decoration: underline; }\n}\n\n// Searchable organization combobox\n.inv-orgselect {\n  position: relative;\n  margin-top: 6px;\n\n  &__control {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    width: 100%;\n    text-align: left;\n    cursor: pointer;\n\n    &.is-placeholder .inv-orgselect__value { color: $color-neutral-mid; }\n  }\n  &__value { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n  &__caret { color: $color-neutral-mid; font-size: 13px; flex-shrink: 0; transition: transform 0.15s ease; }\n  &.is-open &__caret { transform: rotate(180deg); }\n\n  &__menu {\n    position: absolute;\n    z-index: 20;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    background: #fff;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    box-shadow: 0 8px 24px -12px rgba(#333, 0.28), 0 2px 6px rgba(#333, 0.06);\n    overflow: hidden;\n  }\n\n  &__search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 9px 12px;\n    border-bottom: 1px solid $color-grey-1;\n\n    .fa { color: $color-neutral-mid; font-size: 13px; }\n  }\n  &__search-input {\n    flex: 1;\n    border: none;\n    outline: none;\n    padding: 0;\n    font-family: $font-stack;\n    font-size: 13px;\n    color: $body-content-color;\n    background: transparent;\n    &::placeholder { color: $color-neutral-mid; }\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0;\n    padding: 4px;\n    max-height: 220px;\n    overflow-y: auto;\n  }\n  &__option {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 8px 10px;\n    border-radius: 5px;\n    font-size: 13px;\n    color: $body-content-color;\n    cursor: pointer;\n\n    .fa-check { color: $develop-color; font-size: 12px; flex-shrink: 0; }\n    &.is-active { background: rgba($clarify-color, 0.1); }\n    &.is-selected { font-weight: 600; }\n  }\n  &__option-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n  &__empty {\n    padding: 12px 10px;\n    font-size: 13px;\n    color: $color-neutral-mid;\n    text-align: center;\n    line-height: 1.5;\n  }\n  &__create {\n    display: inline;\n    border: none;\n    background: none;\n    padding: 0;\n    margin-left: 4px;\n    font-family: $font-stack;\n    font-size: 13px;\n    font-weight: 600;\n    color: $develop-color;\n    cursor: pointer;\n    &:hover { text-decoration: underline; }\n  }\n}\n\n.inv-neworg {\n  margin-top: 6px;\n  padding: 12px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  background: $color-neutral-light;\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 10px;\n  }\n  .btn-xs { padding: 5px 12px; font-size: 12px; }\n}\n\n// Follow-up reminder toggle + preview help icon\n.inv-followup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  &__toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n    font-size: 13px;\n    color: $body-content-color;\n    cursor: pointer;\n\n    input { cursor: pointer; margin: 0; }\n  }\n\n  // Pushed to the right of the toggle row — opens the coaching-emails preview.\n  &__sample {\n    margin-left: auto;\n    border: none;\n    background: none;\n    color: $clarify-color;\n    cursor: pointer;\n    font-size: 12.5px;\n    font-weight: 600;\n    font-family: $font-stack;\n    line-height: 1;\n    padding: 4px 2px;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    transition: color 0.15s ease;\n\n    &:hover { color: darken($clarify-color, 12%); }\n    &:focus-visible { outline: 2px solid $clarify-color; outline-offset: 2px; border-radius: 3px; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
